/*
 * Copyright (c) 2020  Apricad LLC. All Rights Reserved.
 */

import { createMuiTheme } from "@material-ui/core/styles";

export const theme = createMuiTheme({
  palette: {
    primary: {
      light: "#E9A724", // (233, 167, 36)
      main: "#E98D24", // (233, 141, 36)
      dark: "#C47E2D", // (196, 126, 45)
      contrastText: "#f9f9f9",
    },
    secondary: {
      light: "#9DD455",
      main: "#8AB058", // (138 176 88)
      dark: "#638C38",
      contrastText: "#f9f9f9",
    },
    test: {
      main: "#2D73C4",
    },
    info: {
      light: "#9870AB", // org: #464FC8",
      main: "#422550", // org: #252850 ( 37, 40, 80)
      dark: "#252850",
      contrastText: "#f9f9f9",
    },
    warning: {
      light: "#E01E3D",
      main: "#C61D39", // (198 29 57)
      dark: "#A21028",
      contrastText: "#f9f9f9",
    },
    paper: {
      light: "#FBFAF4",
      main: "#F7E9B8",
      dark: "#F2DE99",
      contrastText: "#f9f9f9",
    },
    gray: {
      light: "#F0F0F0",
      main: "#9E9E9E",
      dark: "#616161",
      contrastText: "#f9f9f9",
    },
    notes: {
      light: "#B6B7E2",
      main: "#9091CC",
      dark: "#57589E",
      background: "#F4F4FF",
      contrastText: "#f9f9f9",
    },
    background: {
      main: "#F2EAE1",
    },
  },
  typography: {
    fontFamily: [
      "Open Sans",
      "Helvetica",
      "Arial",
      "sans-serif",
      '"Apple Color Emoji"',
      '"Segoe UI Emoji"',
      '"Segoe UI Symbol"',
    ].join(","),
  },
  breakpoints: {
    values: {
      xs: 0,
      sm: 600,
      md: 960,
      lg: 1440,
      xl: 1920,
    },
  },
});
